class BoundaryFactory {
    switchObject;

    constructor() {
        this.switchObject = {};
    }

    register(type, creator) {
        this.switchObject[type] = creator;
    }

    create(props) {
        const creator = this.switchObject[props.type];
        if (creator) return new creator(props);
        throw new Error("invalid boundary type: "+ props.type);
    }
}

export default new BoundaryFactory();
